import React from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { isUserAuthorized } from '../Authorization';
import Dropdown from '../../components/Dropdown';
import Icon from '../../components/Icon';
import HelpLink from '../HelpLink';
import LanguageSwitcher from '../LanguageSwitcher';
import './styles.css';

const messages = defineMessages({
  helpDropdown: {
    id: 'help.dropdown',
    defaultMessage: 'Help Dropdown',
  },
  support: {
    id: 'help.support',
    defaultMessage: 'Contact Support',
  },
});

class HelpNavMenu extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    viewer: PropTypes.object,
  };

  render() {
    const { intl, viewer } = this.props;
    if (isUserAuthorized(viewer) && !viewer.isNaviance) {
      return (
        <Dropdown
          aria-label={intl.formatMessage(messages.helpDropdown)}
          selectOnBlur={false}
          selectOnNavigation={false}
          styleName="helpDropdown"
          id="helpNav-dropdown"
          pointing="top right"
          className="hidden-mobile"
          floating
          icon={null}
          trigger={(
            <Icon
              name="help circle"
              size="huge"
              styleName="helpIconNavUpdate"
            />
          )}
        >
          <Dropdown.Menu>
            <HelpLink idPrefix="helpNavMenu" messageId="app.topNavMenu.help" defaultMessage="Help Center" />
            {!viewer.isNaviance && (
              <a className="item" href={`mailto:${process.env.COUNSELOR_COMMUNITY_EMAIL}`}>
                <FormattedMessage {...messages.support} />
              </a>
            )}
            {process.env.LANGUAGE_SWITCHER &&
              <Dropdown.Item as={LanguageSwitcher} />}
          </Dropdown.Menu>
        </Dropdown>
      );
    } else return null;
  }
}

const mapStateToProps = (state) => ({
  viewer: get(state, 'current.viewer'),
});

export default connect(mapStateToProps)(injectIntl(HelpNavMenu));
